import { Check, ChevronDown } from "lucide-react";
import { Select as S } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { surface } from "./foundation";
export const Select = S.Root;
export const SelectValue = S.Value;
export const SelectGroup = S.Group;
export const SelectLabel = surface(
  S.Label,
  "select-label",
  "px-2 py-1 text-xs text-muted-foreground",
);
export const SelectSeparator = surface(S.Separator, "select-separator", "my-1 border-t");
export function SelectTrigger({
  children,
  className,
  size: _size,
  ...props
}: ComponentProps<typeof S.Trigger> & { size?: "sm" | "default" }) {
  return (
    <S.Trigger
      {...props}
      data-slot="select-trigger"
      className={cn("cyra-input flex items-center justify-between gap-2", className)}
    >
      {children}
      <S.Icon>
        <ChevronDown aria-hidden className="size-4" />
      </S.Icon>
    </S.Trigger>
  );
}
export function SelectContent({
  children,
  className,
  position = "popper",
  ...props
}: ComponentProps<typeof S.Content>) {
  return (
    <S.Portal>
      <S.Content
        {...props}
        position={position}
        sideOffset={5}
        data-slot="select-content"
        className={cn("cyra-popup min-w-[var(--radix-select-trigger-width)]", className)}
      >
        <S.ScrollUpButton>↑</S.ScrollUpButton>
        <S.Viewport className="p-1">{children}</S.Viewport>
        <S.ScrollDownButton>↓</S.ScrollDownButton>
      </S.Content>
    </S.Portal>
  );
}
export function SelectItem({ children, className, ...props }: ComponentProps<typeof S.Item>) {
  return (
    <S.Item {...props} data-slot="select-item" className={cn("cyra-menu-item", className)}>
      <S.ItemText>{children}</S.ItemText>
      <S.ItemIndicator className="ml-auto">
        <Check aria-hidden className="size-4" />
      </S.ItemIndicator>
    </S.Item>
  );
}
